import dotProp from "dot-prop";
import { actions } from "../react-redux-form";

const invoiceItemSchema = function(state, props) {
  const invoiceConfigId = dotProp.get(state, `entities.invoice.byId.${props.entityId}.senderConfigId`)
  const vatFree = dotProp.get(state, `entities.invoiceConfiguration.byId.${invoiceConfigId}.vatFree`)

  const uiSchema = {
    "position": {
      "ui:widget" :"hidden"
    },
    "description": {
      "ui:options" : {
        "width": 16
      }
    },
    "price": {
      "ui:group": "price_quantity",
      "ui:widget": "PriceWidget",
      "ui:options" : {
        "width": 4
      }
    },
    "quantity": {
      "ui:group": "price_quantity",
      "ui:widget": "NumberWidget",
      "ui:options" : {
        "width": 4
      }
    },
    "consultationId": {
      "ui:widget": "hidden"
    },
    "unit": {
      "ui:group": "price_quantity",
      "ui:widget": "select",

      "ui:options" : {
        "width": 4,
        selectOptions: [
          {key: 'session',  value: 'session', text: I18n.t('components.invoice_form.unit.session') },
          {key: 'hours', value: 'hours', text: I18n.t('components.invoice_form.unit.hours') },
          {key: 'km',  value: 'km', text: I18n.t('components.invoice_form.unit.km') },
          {key: 'piece',  value: 'piece', text: I18n.t('components.invoice_form.unit.piece') },
        ]
      }
    },
    "vatPercentage": {
      "ui:group": "price_quantity",
      "ui:widget": vatFree ? "hidden" : "PercentageWidget",
      "ui:options" : {
        "width": 2
      }
    }
  }

  return uiSchema
}

export default invoiceItemSchema
